import React, { useState } from 'react'
import DashHeader from '../mini/DashHeader';
import { useParams, NavLink } from 'react-router-dom';
import { useFetchDocumentsQuery, useRidersQuery } from '../../redux/services/usersApi';
import ClipLoader from "react-spinners/ClipLoader";
import ImageModal from "../mini/imageModal/ImageModal";

const Documents = () => {
    
    const { riderId } = useParams()
    const [docModal, setDocModal] = useState(null)
    const { selectedUser } = useRidersQuery(undefined, {
        selectFromResult: ({data}) => ({
            selectedUser: data?.users?.find((us) => us._id === riderId)
        })
    })

    const { data, isLoading, error } = useFetchDocumentsQuery(riderId)
    const driversLicense = !isLoading ? data?.data?.driversLicense : null
    const validId = !isLoading ? data?.data?.validID : null
    const bikeReceipt = !isLoading ? data?.data?.bikeReceipt : null

    if (!isLoading && error) {
        console.log(error)
    }

    window.onclick = function(event) {

        const modal = document.querySelector("#docModal")
        
        if (event.target === modal) {
            setDocModal(null)
        }
    }

    return (
        <>
            <DashHeader title={selectedUser?.fullName} />
            <nav className='mt-2 d-flex nav-tab'>
                <NavLink to={"/dashboard/rider/"+riderId} className="text-decoration-none d-inline-block ps-0 p-2 my-2 border-bottom-1 top-tab">
                    General information
                </NavLink>
                <NavLink to={"/dashboard/rider-history/"+riderId} className="text-decoration-none d-inline-block p-2 my-2 border-bottom-1 top-tab">
                    Rider History
                </NavLink>
                <NavLink to={"/dashboard/statements/"+riderId} className="text-decoration-none d-inline-block p-2 my-2 border-bottom-1 top-tab">
                    Statements
                </NavLink>
                <NavLink to={"/dashboard/documents/"+riderId} className="text-decoration-none d-inline-block pe-4 p-2 my-2 border-bottom-1 top-tab active-top-tab">
                    Documents
                </NavLink>
            </nav>
            <div className="pull-up">
                <div className="content row mt-5">
                    { isLoading && <ClipLoader color="#fdc51c" size={30} /> }
                    { error && error?.data?.message }
                    {
                        driversLicense &&
                        <div className="col-md-4 mb-3">
                            <div className="card border-light me-4 p-4">
                                <h6 className="mb-4">Drivers License</h6>
                                <button className="btn btn-basic border-light view-btn" onClick={() => {setDocModal(driversLicense)}}>View</button>
                            </div>
                        </div>
                    }
                    {
                        validId &&
                        <div className="col-md-4 mb-3">
                            <div className="card border-light me-4 p-4">
                                <h6 className="mb-4">Valid ID Card</h6>
                                <button className="btn btn-basic border-light view-btn" onClick={() => {setDocModal(validId)}}>View</button>
                            </div>
                        </div>
                    }
                    {
                        bikeReceipt &&
                        <div className="col-md-4 mb-3">
                            <div className="card border-light me-4 p-4">
                                <h6 className="mb-4">Bike Receipt</h6>
                                <button className="btn btn-basic border-light view-btn" onClick={() => {setDocModal(bikeReceipt)}}>View</button>
                            </div>
                        </div>
                    }
                </div>
                
                { docModal && 
                    <ImageModal modalObj={docModal} closer={() => setDocModal(null)} />
                }
            </div>
        </>
    )
}

export default Documents
